(() => {
  if (window.GRLSstProductCards) return;
  window.GRLSstProductCards = true;

  const refreshCart = () => {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: true },
    }));
  };

  const addVariant = async (control, variantId) => {
    if (!variantId || control.dataset.loading === 'true') return;
    control.dataset.loading = 'true';
    control.classList.add('loading');
    if ('disabled' in control) control.disabled = true;

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      refreshCart();
    } catch (error) {
      const fallback = new URL(`${window.Shopify?.routes?.root || '/'}cart/add`, window.location.origin);
      fallback.searchParams.set('id', variantId);
      fallback.searchParams.set('quantity', '1');
      window.location.assign(fallback.toString());
    } finally {
      delete control.dataset.loading;
      control.classList.remove('loading');
      if ('disabled' in control) control.disabled = false;
    }
  };

  const activate = (event, control) => {
    event.preventDefault();
    event.stopPropagation();

    if (control.matches('[data-sst-add-size]')) {
      if (control.dataset.available !== 'true') return;
      addVariant(control, control.dataset.variantId);
      return;
    }

    const productDomId = control.dataset.productDomId;
    const form = document.getElementById(`simple-form-${productDomId}`);
    addVariant(control, form?.querySelector('[name="id"]')?.value);
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-sst-add-size], [data-sst-add-single]');
    if (control) activate(event, control);
  });

  document.addEventListener('keydown', (event) => {
    if (!['Enter', ' '].includes(event.key)) return;
    const control = event.target.closest('[data-sst-add-size]');
    if (control) activate(event, control);
  });
})();
